import { AssessmentMode } from 'constants/assessmentMode';

export const isAssessmentFinalized = (status) => {
  return (
    status === AssessmentMode.ReviewAndFinalizeWizard ||
    status === AssessmentMode.ReviewAndFinalizeWizardEditable
  );
};
